import { createElement } from 'react';
import { useReactDndConstructs } from '../../../dnd/ReactDndContext';
import { TreeNode } from '../TreeNode';
import { BadgeButton } from '../../BadgeButton';
import { TestIdProps } from '../../../util/testId';
import { DragPreview } from '../../../dnd/view/DragPreview';
import cn from './Dnd.css.json';
import './Dnd.css';

export interface TreeNodeDragPreviewProps extends TestIdProps {
  dndPrefix: string;
  dragType: string;
  draggedNodeCount?: number;
}

export const TreeNodeDragPreview = (props: TreeNodeDragPreviewProps) => {
  const { useDragLayer } = useReactDndConstructs();

  const { itemType, item, clientOffset } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    clientOffset: monitor.getClientOffset(),
  }));

  const renderItem = () => {
    switch (itemType) {
      case props.dragType:
        return (
          <TreeNode
            node={item.node}
            selected={false}
            expanded={false}
            hasChildren={Array.isArray(item.node.children) && item.node.children.length > 0}
          />
        );
      default:
        return null;
    }
  };

  const dragCount = props.draggedNodeCount ?? 1;

  if (!item || !clientOffset) return null;

  return (
    <DragPreview
      className={cn.dragImagePreview}
      style={{
        transform: `translate3d(${clientOffset.x}px, ${clientOffset.y}px, 0px)`,
        width: item?.width,
      }}
    >
      {item.dndPrefix === props.dndPrefix ? renderItem() : null}
      {dragCount > 1 && (
        <BadgeButton className={cn.nodeCount} value={dragCount} badgeDesign="square" />
      )}
    </DragPreview>
  );
};
